module.exports = __webpack_public_path__ + "static/media/main_slider_3.bd0ef454.jpg";